import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "profile-form" */ './StudentProfileFormCtnr'));

export { default as ProfileFormCoursesSelect } from './ProfileFormCoursesSelect';
export { default as ProfileFormSchoolSelect } from './ProfileFormSchoolSelect';
